import { combineEpics } from "redux-observable";

import appConfigEpic from "@/app-config-epic";
import scrollToEpic from "@/util/scrollTo.epic";
import loginPageEpic from "@/components/loginPage/LoginPage.epic";
import alertTimeoutEpic from "@/components/alerts/Alerts.epic";
import paymentEpic from "@/components/payment/epic";
import requestCurrentUserEpic from "@/components/currentUser/CurrentUser.epic";
import requestAgenciesEpic from "@/components/currentUser/Agencies.epic";
import adminPageEpic from "@/components/adminPage/AdminPage.epic";
import administeredUsersEpic from "@/components/administeredUsers/AdministeredUsers.epic";
import userSettingsPageEpic from "@/components/userSettingsPage/UserSettingsPage.epic";
import profilePageEpic from "@/components/profilePage/ProfilePage.epic";
import requestPeriscopeDashboardEpic from "@/components/periscopeDashboard/PeriscopeDashboard.epic";
import transactionSearchEpic from "@/components/transactionSearchPage/TransactionSearchPage.epic";
import transactionSearchResultsEpic from "@/components/transactionSearchResults/pagination.epic";
import transactionSearchV2BetaEpic from "@/components/transactionSearchPageV2Beta/TransactionSearchPageV2Beta.epic";
import transactionSearchResultsV2BetaEpic from "@/components/transactionSearchResultsV2Beta/pagination.epic";
import customerSearchEpic from "@/components/customerSearchPage/CustomerSearchPage.epic";

const rootEpic = () =>
  combineEpics(
    loginPageEpic,
    appConfigEpic,
    scrollToEpic,
    alertTimeoutEpic,
    transactionSearchEpic,
    paymentEpic,
    requestCurrentUserEpic,
    requestAgenciesEpic,
    adminPageEpic,
    administeredUsersEpic,
    userSettingsPageEpic,
    profilePageEpic,
    requestPeriscopeDashboardEpic,
    transactionSearchResultsEpic,
    transactionSearchV2BetaEpic,
    transactionSearchResultsV2BetaEpic,
    customerSearchEpic
  );

export default rootEpic;
